import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of, tap } from 'rxjs';
import { backendEndPointToken } from '../app.config';
import { StateService } from '../shared/state.service';
import { Bundle, BundleEntry, Condition } from 'fhir/r4';


export const patCondResolver: ResolveFn<any> = (route, state) => {
  const http = inject(HttpClient);
  const backend = inject(backendEndPointToken);
  const stateService = inject(StateService);

  const patientId: string = (route.parent?.params?.['id'] ?? route.params?.['id'] ?? '').toString();
  const endpoint = patientId
    ? `${backend}/Condition?patient=${encodeURIComponent(patientId)}&_count=200&_format=json`
    : `${backend}/Condition?_count=200&_format=json`;

  const fromBackend$ = http.get<Bundle<Condition>>(endpoint).pipe(
    map((bundle) => (bundle.entry ?? []).map((e: BundleEntry<Condition>) => e.resource).filter(Boolean) as Condition[])
  );

  const fromFixture$ = http.get<any>('condition_bundle.json').pipe(
    map((jsonObject: any) => (jsonObject?.entry ?? []).map((e: any) => e.resource).filter(Boolean) as Condition[]),
    catchError(() => of([] as Condition[]))
  );

  return fromBackend$.pipe(
    catchError(() => fromFixture$),
    tap((conditions: Condition[]) => {
      stateService.PatientResources.condition.next(
        (conditions || []).map((condition: any) => ({
          referenceId: condition.id ? `Condition/${condition.id}` : null,
          savedStatus: 'saved',
          actualResource: condition
        }))
      );
    }),
    map((conditions: Condition[]) => ({ conditions }))
  );
};
